export default "__VITE_ASSET__C3LRVo5t__"